import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import useSiteSettingsStore from '~/stores/useSiteSettingsStore';
export default defineNuxtRouteMiddleware(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var siteSettingsStore;
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        siteSettingsStore = useSiteSettingsStore();
        _context.next = 3;
        return siteSettingsStore.fetch();
      case 3:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));